module.exports = __webpack_public_path__ + "media/images/icons/material/help-e22705f1a50453da4b5409e8a9471b94.svg";